import * as actionTypes from './CommunicationActionType';

export const getCommunicationRequest = (data) => ({
    type: actionTypes.GET_COMMUNICATIONS_REQUEST,
    payload: data,
});
export const getCommunicationSuccess = (data) => ({
    type: actionTypes.GET_COMMUNICATIONS_SUCCESS,
    payload: data,
});
export const getCommunicationFailure = (error) => ({
    type: actionTypes.GET_COMMUNICATIONS_FAILURE,
    payload: error,
});

export const getNotificationsRequest = (data) => ({
    type: actionTypes.GET_NOTIFICATIONS_REQUEST,
    payload: data,
});
export const getNotificationsSuccess = (data) => ({
    type: actionTypes.GET_NOTIFICATIONS_SUCCESS,
    payload: data,
});
export const getNotificationsFailure = (error) => ({
    type: actionTypes.GET_NOTIFICATIONS_FAILURE,
    payload: error,
});

export const getCommunicationNotificationRequest = (data) => ({
    type: actionTypes.GET_COMMUNICATION_NOTIFICATION_REQUEST,
    payload: data,
});
export const getCommunicationNotificationSuccess = (data) => ({
    type: actionTypes.GET_COMMUNICATION_NOTIFICATION_SUCCESS,
    payload: data,
});
export const getCommunicationNotificationFailure = (error) => ({
    type: actionTypes.GET_COMMUNICATION_NOTIFICATION_FAILURE,
    payload: error,
});

export const getAllOtherCommunicationsRequest = (data) => ({
    type: actionTypes.GET_ALL_OTHER_COMMUNICATIONS_REQUEST,
    payload: data,
});
export const getAllOtherCommunicationsSuccess = (data) => ({
    type: actionTypes.GET_ALL_OTHER_COMMUNICATIONS_SUCCESS,
    payload: data,
});
export const getAllOtherCommunicationsFailure = (error) => ({
    type: actionTypes.GET_ALL_OTHER_COMMUNICATIONS_FAILURE,
    payload: error,
});

export const logNotificationViewRequest = (payload) => ({
    type: actionTypes.LOG_NOTIFICATION_VIEW_REQUEST,
    payload
});